<p-datepicker
  [inputId]="inputId"
  [ngModel]="selectedDate"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onDateChange($event)"
  (onBlur)="onBlur()"
  [disabled]="isDisabled"
  [minDate]="minDate"
  [maxDate]="maxDate"
  view="month"
  [dateFormat]="dateFormat"
  [placeholder]="placeholder"
  [inline]="inline"
  [showIcon]="!inline"
  [showButtonBar]="true"
  appendTo="body"
  [style]="{ width: '100%' }"
  [class.ng-invalid]="invalid"
  [inputStyleClass]="invalid ? 'border border-red-500' : ''"
  [panelStyle]="panelStyle"
>
  <ng-template #header>
    @if (heading) {
      <p class="pb-2 text-lg font-semibold">{{ heading }}</p>
    }
  </ng-template>
</p-datepicker>
